import React, {
	useContext,
	useEffect,
	useState,
	useCallback,
	useMemo,
} from 'react'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { checkIsMobile, CircleSpinner } from 'shared'

import {
	ITermItem,
	termItemsCard,
	termItemsDeposit,
	termItemsDepositFixed,
} from './termsConstants'
import SspContext from 'selfServicePortal/contexts/SspContext'
import getSspTermsService, {
	SspLinkData,
} from 'selfServicePortal/services/CustomerServices/SspTermsService'

import './Terms.scss'

export const Terms = () => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { isCard, productType, overviewData } = useContext(SspContext)

	const terms = useMemo(() => {
		return isCard?.isCard
			? termItemsCard
			: productType === 'Deposit_Fixed'
			  ? termItemsDepositFixed
			  : termItemsDeposit
	}, [isCard, productType])

	const [sspLinkData, setSspLinkData] = useState<SspLinkData[]>([])
	const [termsDoc, setTermsDoc] = useState<ITermItem[]>([])
	const [loading, setLoading] = useState<boolean>(true)
	const [error, setError] = useState<boolean>(false)

	const getTerms = useCallback(() => {
		try {
			const supportedCountries = ['de', 'at', 'no', 'es', 'it']
			if (supportedCountries.includes(appConfig.country)) {
				const countryTerms = terms.items.filter(
					(i) => i.country === appConfig.country,
				)
				setTermsDoc(countryTerms)
			} else {
				setTermsDoc([])
			}
		} catch (error) {
			console.error('Error fetching terms:', error)
			setTermsDoc([])
		}
	}, [terms])

	useEffect(() => {
		getTerms()
	}, [getTerms])

	const getTermsDocuments = useCallback(async () => {
		try {
			const result = await getSspTermsService()
			setSspLinkData(result)
		} catch (err) {
			console.warn(
				'Something went wrong trying to fetch links for terms: ',
				err,
			)
			setError(true)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		getTermsDocuments()
	}, [getTermsDocuments])

	return (
		<div className="fade-in terms container">
			<div
				className={
					isMobile ? 'mobile containeCls' : 'desktop containerCls'
				}>
				<div className="title d-flex justify-content-center mt-4">
					<h2>{t(terms.title)}</h2>
				</div>
				{loading ? (
					<CircleSpinner />
				) : (
					<>
						{error ? (
							<div className="error-msg">{t('ErrorMsg')}</div>
						) : (
							<div
								className={
									isMobile
										? 'mobile itemContainerCls'
										: 'desktop itemContainerCls'
								}>
								{termsDoc.map((item, key) => {
									if (
										(overviewData?.productId ===
											'BBF.VISA_VSDC_CL.CRDACC_P1' ||
											overviewData?.productId ===
												'BBF.VISA_VSDC_CG.CRDACC_P6') &&
										item.title === 'InsuraceCondition'
									) {
										return null
									}
									return (
										<div key={key}>
											{sspLinkData
												.filter(
													(link) =>
														link.partitionKey ===
															item.id &&
														link.link !== '',
												)
												.map((link, index) => (
													<a
														href={link.link}
														rel="noopener noreferrer"
														key={`terms-link-${index}`}
														target="_blank"
														className={
															isMobile
																? 'mobile linkCls'
																: 'desktop linkCls'
														}>
														<img
															src={item.icon}
															alt={`icon + ${item.title}`}
														/>
														<div className="terms-title">
															{t(item.title)}
														</div>
													</a>
												))}
										</div>
									)
								})}
							</div>
						)}
					</>
				)}
			</div>
		</div>
	)
}
